module.exports = "<p>\r\n  Cargando...\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/logout/logout.component.html
// module id = ../../../../../src/app/components/logout/logout.component.html
// module chunks = main